import { AxiosService } from './axios.service'

const baseURL = 'cliente/verificar'

/**
 * Defines the API methods for client register verification
 */
export class ClientRegisterVerificationService {
	/**
	 * Check the client registration
	 */
	static checkRegistration(params) {
		return AxiosService.get(baseURL, {
			params
		}).then(({ data }) => data)
	}
}
